<template>
  <v-row>
    <v-col v-for="n in 9" :key="n" class="d-flex child-flex" cols="4">
      <v-img
        :src="`https://loremflickr.com/320/240?random=${n + 1}`"
        :lazy-src="`https://loremflickr.com/320/240?random=${n + 1}`"
        aspect-ratio="1"
        class="grey lighten-2"
      >
        <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="grey lighten-5"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
      default:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur,natus eius fugiat minus quis aperiam laboriosam aliquid suscipit fugit vel dolorem minima. Cumque, explicabo? Eum magnam ullam perferendis doloribus? Eos!",
    },

    data: {
      type: String,
    },
  },
  data() {
    return {};
  },
};
</script>
